'use client'

import { cn } from '@/lib/utils'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { Button } from '../ui/button'

export default function LoginButton({ className }) {
  const pathname = usePathname()

  return (
    <Button
      variant="outline"
      type="button"
      className={cn('h-full min-h-[44px] w-full px-3', className)}
      asChild
    >
      <Link href={`/auth/login?redirectUrl=${pathname}`}>Login / Register</Link>
    </Button>
  )
}
